<div id="about-us" class="mt-5 pt-5">
    <div class="container">

        <!-- Title Section -->
        <div class="row">
            <div class="col-12">
                <div class="about-details">
                    <div class="sub-title">
                        <p>Welcome to</p>
                    </div>
                    <h2 class="home-title">Aryakulam International School</h2>
                </div>
            </div>
        </div>

        <!-- Content Section -->
        <div class="row align-items-center">

            <!-- LEFT: ABOUT BOX -->
            <div class="col-12 col-lg-6">
                <div class="about-details">
                    <ul class="ps-0 mt-3">
                        <li>
                            <div class="card">
                                <div class="card-body p-0">
                                    <h3 class="dark-shadow">About School</h3>
                                    <p class="mb-0 normal-shadow">
                                        <strong>ARYAKULAM International School – Munak (Karnal)</strong>, established in
                                        the year <strong>2019</strong>
                                        under the esteemed management of <strong>Shree Rehtu Ram Memorial
                                            Sabha</strong>,
                                        stands as a
                                        progressive centre of learning dedicated to nurturing young minds with
                                        excellence, discipline, and strong moral values. Being a CBSE-affiliated
                                        institution, the school is committed to delivering quality education that blends
                                        academic rigor with character building. Guided by its inspiring motto
                                        <strong>“ज्ञानम्
                                            परम् बलम्” (Knowledge is the Supreme Strength)</strong>, the institution
                                        believes that
                                        education is the most powerful instrument to shape responsible citizens and
                                        enlightened leaders for the nation.
                                    </p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- RIGHT: IMAGE -->
            <div class="col-12 col-lg-6 text-center">
                <div class="image-container">
                    <div class="inner">
                        <a href="/assets/img/showcase/1.jpg" data-lightbox="about-us">
                            <img src="/assets/img/showcase/1.jpg" alt="Aryakulam International School" />
                        </a>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>